import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { TableWrapper, TableSection, Header } from '../dashBoardStyled'
import { Table } from 'reactstrap';
import Spinner from '../../../../../components/Spinner'
import { fetchOrderDetailsList } from '../../../../../../redux/actions/admin';
import Pagination from '@material-ui/lab/Pagination';

function OrderDetailList(props) {
    let history = useHistory()
    let dispatch = useDispatch()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const location = useLocation();
    const [tableData, setTableData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [csvData, setCsvData] = useState([])

    const [headerArr, setHeaderArray] = useState([
        { title: 'Order Id', },
        { title: 'Assigned To' },
        { title: 'Assigned From' },
        { title: 'Commodity', },
        { title: 'Quantity', },
        { title: 'Price', },
        { title: 'Location', },
        { title: 'Email', }
    ])
    const [columns, setColumns] = useState([
        { id: 'OrderId', displayName: 'Order Id' },
        { id: 'Assigned To', title: 'Assigned To' },
        { id: 'Assigned From', title: 'Assigned From' },
        { id: 'Commodity', displayName: 'Commodity' },
        { id: 'Quantity', displayName: 'Quantity' },
        { id: 'Price', displayName: 'Price' },
        { id: 'Location', displayName: 'Location' },
        { id: 'Email', displayName: 'Email' }
    ])
    useEffect(() => {
        fetchMyAPI(page);
    }, []);


    // fetch orderdetails list
    const fetchMyAPI = async (pageNumber) => {

        let typeOfOrderList
        if (location?.state?.data?.typeOrder !== undefined || sessionStorage.getItem('orderDataList') !== null) {
            if (location?.state?.data) {
                sessionStorage.setItem('orderDataList', JSON.stringify(location.state.data))
                typeOfOrderList = location.state.data
            }
            else {
                typeOfOrderList = JSON.parse(sessionStorage.getItem("orderDataList"))

            }

            let response = '';
            response = await dispatch(fetchOrderDetailsList(pageNumber, typeOfOrderList))
            if (response.data && response.data.status === 'SUCCESS') {
                if (response.data?.payload?.content) {
                    setTableData(response.data?.payload?.content)
                    setPageCount(response.data?.payload?.totalPages)
                    setCsvData(response.data?.payload?.content)
                }
            }
            else {
                if (response.statusCode === 401) {
                    localStorage.removeItem('token')
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {

                }
            }
        }

    };
    const handleChange = (event, value) => {
        setPage(value);
        fetchMyAPI(value)
    };

    return (
        <div>
            <TableWrapper>
                {loaderVisible && <Spinner />}
                <Header style={{ height: '55px' }}>
                    <h3>Order List</h3>
                </Header>
                <TableSection>
                    <Table responsive>
                        <thead>
                            <tr>
                                {headerArr.map((items, index) => (
                                    <th key={index}>{items.title}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tableData.map((items, index) => (
                                    <tr key={index}>
                                        <td>{items.id}</td>
                                        <td>{items.buyerInfo.companyName}</td>
                                        <td>{items.sellerInfo.companyName}</td>
                                        <td>{items.orderDetails.commodity.commodityName}</td>
                                        <td>{items.orderDetails.quantity}</td>
                                        <td>{`$${items.orderDetails.pricePerPallet}`}</td>
                                        <td>{`${items.buyerInfo.city} ${items.buyerInfo.state}`}</td>
                                        <td>{items.buyerInfo.email}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </TableSection>
                {tableData.length != 0 && tableData.length !== 0 && <Pagination count={pageCount}
                    page={page}
                    onChange={handleChange} />}
            </TableWrapper>
        </div>
    )

}

export default OrderDetailList